import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_PATH,
});

const workspace = axios.create({
  baseURL: process.env.REACT_APP_WORKSPACE_API_PATH,
});

const ventures = axios.create({
  baseURL: process.env.REACT_APP_VENTURES_API,
  timeout: parseInt(process.env.REACT_APP_VENTURES_API_TIMEOUT || '5000'),
});

const pdfWorkspace = axios.create({
  baseURL: process.env.REACT_APP_PDF_WORKSPACE_API_PATH,
});

const apiNx = axios.create({
  baseURL: process.env.REACT_APP_API_NX_PATH,
});

const apiTranslate = axios.create({
  baseURL: process.env.REACT_APP_GOOGLE_TRANSLATE_PATH,
});

// DÍVIDA TÉCNICA: esta função (e setPrescriptionIdHeader abaixo) registra um novo
// interceptor de request a cada chamada, sem fazer eject dos anteriores — eles se acumulam.
// Como request interceptors do axios rodam em ordem reversa (LIFO) e todos escrevem o mesmo
// header, o PRIMEIRO token registrado prevalece. Hoje é inofensivo porque dentro de um
// carregamento o valor é sempre o mesmo, mas se o token/prescriptionId mudar sem reload
// (refresh, troca de contexto/prescrição) as requests passarão a usar o valor ANTIGO → 401
// ou x-prescription-id errado. Correção: registrar 1 interceptor por instância no boot, lendo
// de uma variável mutável que esta função apenas atualiza.
const setAuthorizationHeader = (authorizationToken: string) => {
  const authorizationType = authorizationToken.startsWith('jwt-mevo-') ? 'Bearer' : 'Basic';
  const token = `${authorizationType} ${authorizationToken.replace(/jwt-mevo-/gi, '')}`;
  const venturesBasic = `${authorizationType} ${process.env.REACT_APP_VENTURES_BASIC}`;

  api.interceptors.request.use((config) => {
    config.headers.Authorization = `${token}`;
    return config;
  });

  workspace.interceptors.request.use((config) => {
    config.headers.Authorization = `${token}`;
    return config;
  });

  ventures.interceptors.request.use((config) => {
    config.headers.Authorization = `${authorizationType === 'Basic' ? venturesBasic : token}`;
    return config;
  });

  pdfWorkspace.interceptors.request.use((config) => {
    config.headers.Authorization = `${token}`;
    return config;
  });
};

export const setPrescriptionIdHeader = (prescriptionId: number) => {
  if (!!(window as any).Cypress) return;

  api.interceptors.request.use((config) => {
    config.headers['x-prescription-id'] = `${prescriptionId}`;
    return config;
  });

  workspace.interceptors.request.use((config) => {
    config.headers['x-prescription-id'] = `${prescriptionId}`;
    return config;
  });

  ventures.interceptors.request.use((config) => {
    config.headers['x-prescription-id'] = `${prescriptionId}`;
    return config;
  });

  pdfWorkspace.interceptors.request.use((config) => {
    config.headers['x-prescription-id'] = `${prescriptionId}`;
    return config;
  });
};

export const isRequestCanceled = (error: unknown): boolean => axios.isCancel(error);

export { setAuthorizationHeader, api, apiNx, apiTranslate, workspace, pdfWorkspace, ventures };
